import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dashIfNoValue'
})
export class DashIfNoValuePipe implements PipeTransform {
  transform(value: any): any {
    return value ? value : '-';
  }
}
